// Shared so the shoveler's "see all" link and the router registration
// can't drift. Matches GH's `ROUTES.ACTIVITY_FEED` path.
export const ACTIVITY_FEED_ROUTE = '/activity-feed'
